

































































import {
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import InvestmentLineChart from "@/shared/components/charts/InvestmentLineChart.vue";
import { mixins } from "vue-class-component";
import { formatCurrency } from "@/shared/currency";
import {
  DrivewealthAccountSummary,
  InvestmentCustodian,
  DrivewealthAccountManagementType
} from "@/shared/types";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useHsaDailyBalanceStore } from "@/shared/store/hsaDailyBalance";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";

@Component({
  components: {
    InvestmentLineChart
  }
})
export default class CurrentHoldingsChart extends mixins(ErrorsMixin) {
  formatCurrency = formatCurrency;

  drivewealthStore = useDrivewealthStore();
  hsaBalanceStore = useHsaDailyBalanceStore();
  investmentThresholdStore = useInvestmentThresholdStore();

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: false })
  accountId: number;

  loadChart (): void {
    if (this.accountId) {
      this.drivewealthStore.getAccountSummaryV2({
        username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId
      });
    }

    this.drivewealthStore.loadHsaBalanceAndThreshold({
      username: this.username, partnerId: this.partnerId, accountId: this.accountId
    });
  }

  @Watch("$props", { deep: true })
  reload () {
    this.loadChart();
  }

  mounted (): void {
    this.loadChart();
  }

  get accountSummaryV2 (): DrivewealthAccountSummary {
    return this.drivewealthStore.accountSummaryById(this.accountId);
  }

  get cashAccountBalance (): number {
    return this.hsaBalanceStore.instantBalance.amount || this.hsaBalanceStore.balanceOnFileAmount;
  }

  get hasInvestmentBalance (): boolean {
    return this.investmentBalance > 0;
  }

  get investmentBalance (): number {
    return this.accountSummaryV2.displayBalance;
  }

  get liquidBalance (): number {
    return this.accountSummaryV2.cashBalance;
  }

  get isLoaded (): boolean {
    const accountSummaryV2Loaded = this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
    const balanceThresholdLoaded = this.drivewealthStore.isHsaBalanceAndThresholdLoaded(this.accountId);

    return accountSummaryV2Loaded &&
        balanceThresholdLoaded;
  }

  get isLoading (): boolean {
    return !this.isLoaded;
  }

  get balanceTitleCopy (): string {
    if (this.isLoaded) {
      return this.isManagedAccount ? "Fair Market Value" : "Investment Balance";
    }
    return "Loading...";
  }

  get liquidTitleCopy (): string {
    if (this.isLoaded) {
      return "Liquid Balance (Not Invested)";
    }
    return "Loading...";
  }

  get availableTitleCopy (): string {
    if (this.isLoaded) {
      return "Available to Invest";
    }
    return "Loading...";
  }

  get availableToInvest () {
    return this.drivewealthStore.isHsaBalanceAndThresholdLoaded(this.accountId)
        ? this.drivewealthStore.hsaBalanceBeyondThreshold(this.accountId) : 0;
  }

  get dwInvestmentCustodian (): InvestmentCustodian {
    return InvestmentCustodian.Drivewealth;
  }

  get isManagedAccount (): boolean {
    return this.accountSummaryV2 &&
      this.accountSummaryV2.accountManagementType === DrivewealthAccountManagementType.RiaManaged;
  }
}
